import { commonColors } from './common.colors';
import { ModalColors } from './ui.colors';
import { palette, createColor } from './palette.colors';

/**
 * Repair Details page color definitions
 */
export const repairDetailsColors = {
  mainBackground: createColor(palette.gray.lightWhite, palette.dark.background),
  repairShiftSectionBGColor: createColor(palette.opacity.blue13, palette.blue.pressed),
  repairShiftMainSectionBGColor: createColor(palette.gray.white, palette.dark.content),
  repairShiftTitle: createColor(palette.opacity.blue08, palette.opacity.blue08),
  repairShiftTitleText: createColor(palette.blue.onTint, palette.gray.white),
  repairSiftSubTitle: createColor(palette.opacity.black0D, palette.opacity.black0D),
  repairTitle: createColor(palette.blue.onTint, palette.gray.white),
  repairShiftTime: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  repairSubShiftTime: createColor(palette.blue.onTint, palette.gray.white),
  newRepairCTABGColor: createColor(palette.gray.white, 'transparent'),
  newRepairCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  newRepairCTAText: createColor(palette.gray.darkest, palette.gray.white),
  tabsBGColor: createColor(palette.gray.white, palette.dark.content),
  tabsBorderColor: createColor(palette.gray.neutral, palette.dark.techBorder),
  tabsTextColor: createColor(palette.gray.darkest, palette.blue.soft),
  // WCAG 1.4.3: was palette.blue.primary (#2B78CA, 3.98:1 vs #EAF1FA sky-blue tab bg) → palette.blue.secondary (#1A65B8, ≥4.6:1)
  tabsSelectedColor: createColor(palette.blue.secondary, palette.blue.pressed),
  uploadIconColor: createColor(palette.blue.secondary, palette.blue.selectedText),
  listeningDisableIconVoiceBG:  createColor(palette.blue.secondary, palette.blue.pressed),
  tabsSelectedSubColor: createColor(palette.blue.secondary, palette.blue.selectedItemBG),
  mainTabsSelectedColor: createColor(palette.blue.secondary, palette.blue.secondary),
  mainTabDisabledColor: createColor(palette.gray.white, palette.gray.white),
  tabContainerBG: createColor(palette.gray.white, palette.dark.content),
  tabContainerBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  tabsSelectedTextColor: createColor(palette.gray.white, palette.gray.white),
  partsCountColor: createColor(palette.semantic.orange, palette.semantic.orange),
  tileCardTitle: createColor(palette.blue.onTint, palette.gray.white),
  tileCardStatus: createColor(palette.gray.charcoal, palette.gray.charcoal),
  tileCardCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  tileCardConfirmText: createColor(palette.gray.white, palette.gray.white),
  tileCardCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  tileCardCTABG: createColor(palette.opacity.gray80, palette.dark.cardSelected),
  tileCardCTASelectedText: createColor(palette.gray.darkest, palette.gray.darkest),
  tileCardCTASelectedBorder: createColor(palette.borders.selected, palette.borders.blue),
  titleCardCTASelectedBGColor: createColor(palette.blue.sky, palette.dark.cardSelected),
  tileCardNumberBorder: createColor(palette.gray.borderAlt2, palette.gray.borderAlt2),
  tileCardNumberText: createColor(palette.blue.onTint, palette.gray.white),
  titleCardActionColor: createColor(palette.blue.primary, palette.blue.primary),
  titleCardEditActionColor: createColor(palette.gray.white, 'transparent'),

  repairDetailsTitle: createColor(palette.blue.onTint, palette.gray.white),
  repairHistoryColor: createColor(palette.blue.primary, palette.blue.primary),
  workOrderStatusTitle: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  workOrderStatusRepairTitle: createColor(palette.gray.field, palette.gray.field),
  workOrderStatusDesc: createColor(palette.blue.onTint, palette.gray.white),
  workOrderStatusCTABGColor: createColor(palette.gray.white, 'transparent'),
  workOrderStatusCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  workOrderStatusEnabledCTABGColor: createColor(palette.special.transparent, palette.special.transparent),
  workOrderStatusEnabledCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  workOrderStatusEnabledCTAText: createColor(palette.gray.darkest, palette.dark.textAlt),
  repairDetailsId: createColor(palette.gray.field, palette.gray.field),
  assetInfo: createColor(palette.blue.onTint, palette.gray.white),
  assetInfoDetailsKey: createColor(palette.gray.lightDarkGrey, palette.gray.slateLight),
  assetInfoDetailsValue: createColor(palette.blue.onTint, palette.gray.white),
  progressTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  progressSubTitle: createColor(palette.gray.darker, palette.gray.darker),
  progressSubTitleValue: createColor(palette.gray.field, palette.gray.field),
  progressBarCardSubTitle: createColor(palette.gray.charcoal, palette.gray.charcoal),
  progressBarCardTitleValue: createColor(palette.gray.darker, palette.gray.darker),
  activeTime: createColor(palette.blue.onTint, palette.gray.white),
  activeTimeValue: createColor(palette.gray.darkest, palette.gray.darkest),
  repairStatusCardBorder: createColor(palette.opacity.gray50, palette.dark.techBorder),
  separator: createColor(palette.gray.extraLight, palette.dark.techBorder),
  activeTimeBGColor: createColor(palette.gray.veryLight, palette.gray.veryLight),
  activeTimeBorderColor: createColor(palette.gray.divider, palette.gray.divider),
  taskFlowInactive: createColor(palette.gray.extraLight, palette.gray.extraLight),
  taskFlowActive: createColor(palette.blue.primary, palette.blue.primary),
  completedRepairs: createColor(palette.blue.primary, palette.blue.primary),
  inCompletedRepairs: createColor(palette.gray.neutral, palette.gray.neutral),
  completedRepairsText: createColor(palette.gray.white, palette.gray.white),
  inCompletedRepairsText: createColor(palette.gray.white, palette.gray.zinc),
  enabledText: createColor(palette.gray.black, palette.gray.white),
  disabledText: createColor(palette.gray.black, palette.gray.zinc),
  taskNameBG: createColor(palette.backgrounds.white, palette.gray.lightDarkGrey),

  searchTitle: createColor(palette.gray.field, palette.gray.white),
  ownRequestCTABorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  ownRequestCTAText: createColor(palette.gray.black, palette.dark.textAlt),
  ownRequestCTAIconColor: createColor(palette.gray.black, palette.gray.white),
  searchBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  searchLeftIconColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  searchRightIconColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  searchRightIconBGColor: createColor(palette.gray.lightWhite, palette.gray.lightWhite),
  searchRightIconBorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  searchPlaceHodlerColor: createColor(palette.gray.charcoal, palette.gray.charcoal),
  scanIconBorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  scanIconTextColor: createColor(palette.gray.black, palette.gray.black),
  scanIconBGColor: createColor(palette.gray.white, palette.gray.white),
  partsHistoryCTABorder: createColor(palette.gray.neutral, palette.gray.neutral),
  partsHistoryCTAText: createColor(palette.gray.black, palette.gray.black),
  partsHistoryCTABG: createColor(palette.gray.white, 'transparent'),
  partsHistoryCTAIconColor: createColor(palette.gray.darker, palette.gray.white),
  messagesCTABorder: createColor(palette.gray.white, palette.gray.white),
  messagesCTAText: createColor(palette.gray.black, palette.gray.black),
  messagesCTAIconColor: createColor(palette.gray.black, palette.gray.white),
  messagesCountTextColor: createColor(palette.gray.white, palette.gray.white),
  messagesCountBGColor: createColor(palette.blue.primary, palette.blue.primary),
  configuredTitle: createColor(palette.blue.onTint, palette.gray.white),
  configuredSubTitle: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  submitPartsCTABorder: createColor(palette.gray.white, 'transparent'),
  submitPartsCTAText: createColor(palette.gray.white, palette.gray.white),
  submitPartsCTAIconColor: createColor(palette.gray.white, palette.gray.white),
  submitPartsCountTextColor: createColor(palette.gray.white, palette.gray.white),
  submitPartsBGColor: createColor(palette.blue.primary, palette.blue.primary),
  checkboxColor: createColor(palette.gray.neutral, palette.gray.neutral),
  checkboxSelectedColor: createColor(palette.blue.primary, palette.blue.primary),
  checkboxSelectedIconColor: createColor(palette.gray.white, palette.gray.white),
  qtyBorder: createColor(palette.gray.white, palette.gray.white),
  qtyMinusIconColor: createColor(palette.gray.darker, palette.gray.darker),
  qtyPlusIconColor: createColor(palette.gray.darker, palette.gray.darker),
  qtyTextColor: createColor(palette.gray.darkest, palette.gray.white),
  qtyDotsColor: createColor(palette.gray.darkest, palette.gray.darkest),
  separatorColor: createColor(palette.gray.divider, palette.gray.divider),

  saveCTABGColor: createColor(palette.blue.primary, palette.blue.primary),
  saveCTATitleColor: createColor(palette.gray.white, palette.gray.white),
  saveCTAIconColor: createColor(palette.gray.white, palette.gray.white),
  cancelCTABorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  cancelCTATextColor: createColor(palette.gray.darkest, palette.gray.darkest),

  notesBorder: createColor(palette.gray.neutral, palette.gray.lightDarkGrey),
  notesFilterUnselectBGColor: createColor(palette.opacity.gray80alt, palette.gray.lightGreyBG),
  notesFilterSelectBGColor: createColor(palette.blue.sky, palette.blue.sky),
  notesFilterSelectBorder: createColor(palette.borders.selected, palette.borders.selected),
  notesFilterText: createColor(palette.gray.darkest, palette.dark.textAlt),
  notesMainTitleColor: createColor(palette.gray.field, palette.gray.white),
  notesTitleColor: createColor(palette.blue.onTint, palette.gray.white),
  notesTypeColor: createColor(palette.blue.onTint, palette.gray.white),
  notesDescColor: createColor(palette.gray.lightDarkGrey, palette.gray.slateLight),
  notesUserColor: createColor(palette.blue.onTint, palette.gray.white),
  notesUserBGColor: createColor(palette.backgrounds.white, palette.gray.avatar),
  notesUserDate: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  notesUserDateIcon: createColor(palette.gray.charcoal, palette.dark.textAlt),
  viewFullNoteCTAColor: createColor(palette.blue.primary, palette.blue.primary),
  viewFullNoteIconColor: createColor(palette.blue.primary, palette.blue.primary),
  divider: createColor(palette.gray.extraLight, palette.dark.techBorder),
  notesUserNameColor: createColor(palette.gray.darkest, palette.gray.darkest),

  notesModalBorder: ModalColors.border,
  notedModalBG: ModalColors.background,
  notedModalMainTitle: ModalColors.title,
  noteHeaderSeparator: ModalColors.separator,
  itemSeparator: ModalColors.itemSeparator,
  bottomSeparator: ModalColors.bottomSeparator,
  closeModalIconColor: ModalColors.closeIconColor,
  viewMessageTitle: createColor(palette.gray.charcoal, palette.gray.disabledCTABG),
  notesModalTitle: createColor(palette.blue.onTint, palette.gray.white),
  noteSectionBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  meterCard: createColor(palette.gray.neutral, palette.dark.techBorder),
  noteSectionSelectedBorder: createColor(palette.blue.primary, palette.blue.pressed),
  noteSectionSelectedBG: createColor(palette.opacity.blue08, palette.blue.deep),
  noteSectionTitle: createColor(palette.blue.onTint, palette.gray.disabledCTABG),
  uploadImageTitle: createColor(palette.blue.onTint, palette.gray.white),
  noteSectionValue: createColor(palette.gray.lightDarkGrey, palette.gray.tabDisabledText),
  noteSectionSelectedValue: createColor(palette.gray.lightDarkGrey, palette.gray.tabDisabled),
  noteSectionRadioBorder: createColor(palette.gray.borderAlt2, palette.gray.borderAlt2),
  noteSectionRadioSelectedBorder: createColor(palette.blue.primary, palette.blue.primary),
  noteSectionRadioSelectedBG: createColor(palette.opacity.blue08, palette.opacity.blue08),
  noteSubjectTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  noteSubjectPlaceholder: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  attachmentFileSize: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  charactersText: createColor(palette.gray.placeholderText, palette.gray.tabDisabledText),
  noteSummaryTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  noteSummaryPlaceholder: createColor(palette.gray.charcoal, palette.dark.textAlt),
  noteLog: createColor(palette.blue.onTint, palette.gray.disabledCTABG),
  uploadImageSubTitle: createColor(palette.blue.onTint, palette.gray.white),
  noteLogLeftVal: createColor(palette.blue.onTint, palette.gray.white),
  createdKey: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  createdValue: createColor(palette.gray.darkest, palette.gray.darkest),
  cancelCTABorder: createColor(palette.gray.neutral, 'transparent'),
  changeSelectionBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  cancelCTAText: createColor(palette.gray.darkest, palette.gray.white),
  saveNoteCTAEnabledBG: createColor(palette.blue.primary, palette.blue.primary),
  saveNoteCTAEnabledBGText: createColor(palette.gray.white, palette.gray.white),
  saveNoteCTADisabledBG: createColor(palette.gray.neutral, palette.dark.cardSelected),
  saveNoteCTADisabledText: createColor(palette.gray.darkest, palette.dark.textAlt),
  listeningEnabledCTABG: createColor(palette.blue.primary, palette.blue.primary),
  listeningEnabledCTAText: createColor(palette.gray.white, palette.gray.white),
  listeningEnableIconColor: createColor(palette.gray.white, palette.gray.white),
  listeningEnableIconBG: createColor(palette.blue.primary, palette.blue.primary),
  listeningDisableIconColor: createColor(palette.gray.black, palette.gray.white),
  listeningDisableIconBG: createColor(palette.opacity.gray86, palette.opacity.gray86),
  mandatoryIconColor: commonColors.darkRed,
  mandatoryInputBG: createColor('transparent', palette.backgrounds.badgeRed),
  mandatoryInputBorder: createColor(palette.semantic.dangerRed, palette.semantic.mandatoryRed),
  mandatoryIconBG: createColor(palette.backgrounds.pink, palette.backgrounds.badgeRed),
  errorIconWrapperBG: createColor(palette.semantic.accumultedErrorText, palette.backgrounds.badgeRed),
  errorIconColor: createColor(palette.semantic.mandoratoryRed, palette.semantic.accumultedErrorText),
  errorTextColor: createColor(palette.blue.onTint, palette.gray.white),
  woStatusTitle: createColor(palette.blue.onTint, palette.gray.white),
  woStatusDesc: createColor(palette.blue.onTint, palette.gray.white),
  selectedtabBGColor: createColor(palette.blue.sky, palette.blue.softBlue),
  infoStrip: createColor(palette.blue.sky, palette.gray.lightDarkGrey),
  selectedtabBorder: createColor(palette.borders.selected, palette.gray.placeholderText),
  infoStripBorder: createColor(palette.borders.selected, 'transparent'),
  selectedMeterReading: createColor(palette.blue.deep, palette.gray.placeholderText),
  woStatusSubTitle: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  readingLabel: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  changeModalStubMainTitle: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  agcDropdownBG: createColor(palette.gray.white, palette.blue.softBlue),
  agcDropdownBorder: createColor(palette.borders.dropdownBlue, palette.gray.lightDarkGrey),

  partsSearchResultTitle: createColor(palette.gray.darkest, palette.gray.darkest),
  partsFoundBG: createColor(palette.opacity.gray80, palette.opacity.gray80),
  partsFoundBText: createColor(palette.gray.darker, palette.gray.darker),
  partsResultTitleBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  partsResultTitleColor: createColor(palette.blue.onTint, palette.gray.white),
  partsResultStatus: createColor(palette.gray.darkest, palette.gray.darkest),
  partsResultSubTitleColor: createColor(palette.blue.onTint, palette.gray.white),
  partsResultsPartName: createColor(palette.blue.onTint, palette.gray.white),
  partsResultsPartDesc: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  partsResultDescColor: createColor(palette.gray.lightDarkGrey, palette.gray.tabDisabledText),
  outOfStockColor: createColor(palette.semantic.mandoratoryRed, palette.semantic.accumultedErrorText),
  outOfStockBG: createColor(palette.backgrounds.lightRed, palette.backgrounds.outOfStockBG),
  inStockColor: createColor(palette.semantic.darkGreen, palette.backgrounds.successGreenText),
  inStockBG: createColor(palette.backgrounds.successGreen, palette.semantic.darkSuccessGreen),
  quantityDisableBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  quantityEnableBorder: createColor(palette.gray.neutral, palette.gray.darkGreyLight),
  quantityDisableIconColor: createColor(palette.gray.darker, palette.gray.darker),
  quantityDisableTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  quantityEnableIconColor: createColor(palette.gray.darker, palette.gray.darker),
  quantityEnableTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  addDisabledBG: createColor(palette.gray.neutral, palette.gray.neutral),
  addDisabledText: createColor(palette.gray.darkest, palette.gray.darkest),
  addEnabledBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  addEnabledText: createColor(palette.gray.darkest, palette.gray.darkest),
  closeIconColor: createColor(palette.gray.darker, palette.gray.darker),
  noPartsResultBG: createColor(palette.gray.veryLight, palette.dark.content),
  noPartsResultBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  /** NoPartsFound — large background blob fill.
   *  Light: #F4F4F4. Dark: deepest navy (#001229). */
  noPartsResultIconBG: createColor('#F4F4F4', palette.gray.black),
  /** NoPartsFound — shadow rect + small decorative dots.
   *  Light: #D9D9D9. Dark: pressed navy (#002859). */
  noPartsResultShadowColor: createColor('#D9D9D9', palette.blue.pressed),
  /** NoPartsFound — white document / card / triangle / cloud body fills.
   *  Light: #FFFFFF. Dark: badge blue (#004EA8). */
  noPartsResultDocColor: createColor('#FFFFFF', palette.blue.badge),
  noPartsResultIconText: createColor('#AFAFAF', palette.blue.selectedBorder),
  noPartsResultTitle: createColor(palette.blue.onTint, palette.gray.white),
  noPartsResultDesc: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  primaryIconColor: createColor(palette.gray.white, palette.gray.white),
  messageIconColor: createColor(palette.gray.charcoal, palette.gray.white),

  confirmPartsSubTitle: createColor(palette.gray.charcoal, palette.gray.charcoal),
  header: createColor(palette.gray.darkest, palette.gray.darkest),
  partName: createColor(palette.blue.onTint, palette.gray.white),
  reqQuantity: createColor(palette.gray.darkest, palette.gray.white),
  partNumberKey: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  partNumberValue: createColor(palette.blue.onTint, palette.gray.white),
  partNumberValueBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  partIdKey: createColor(palette.gray.lightDarkGrey, palette.gray.white),
  partIdValue: createColor(palette.gray.field, palette.gray.white),
  partIdValueBorder: createColor(palette.gray.darkest, palette.gray.darkest),
  woDetails: createColor(palette.gray.darkest, palette.gray.darkest),
  bottomTabsKey: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  bottomTabsvalue: createColor(palette.blue.onTint, palette.gray.white),
  bottomTabsBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  separatorLineParts: createColor(palette.gray.borderLight, palette.gray.lightDarkGrey),

  endShiftInfoBG: createColor(palette.backgrounds.warningYellow, palette.backgrounds.shiftContentBG),
  endShiftInfoBorder: createColor(palette.semantic.warningOrange, palette.backgrounds.shiftContentBorder),
  endShiftInfoTitle: createColor(palette.semantic.warningDark, palette.backgrounds.shiftContentTitle),
  endShiftInfoSubTitle: createColor(palette.semantic.warningMedium, palette.backgrounds.shiftContentTitle),
  shiftSummaryTile: createColor(palette.gray.darkest, palette.gray.white),
  shiftSummaryBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  shiftSummaryKey: createColor(palette.gray.charcoal, palette.gray.disabledCTABG),
  shiftSummaryValue: createColor(palette.gray.darkest, palette.gray.white),

  adddQuantity: createColor(palette.gray.slateLight, palette.blue.onTint),
  addPartsNoteBg: createColor(palette.backgrounds.lightBlue, palette.blue.pressed),
  viewNoteBG: createColor(palette.backgrounds.lightWhite, palette.dark.cardSelected),
  viewNoteInfoBorder: createColor(palette.gray.neutral, palette.dark.techBorder),
  addPartsNoteBorder: createColor(palette.borders.blue, palette.blue.badge),
  uploadFileBG: createColor(palette.borders.blue, palette.blue.softBlue),
  addPartsNoteText: createColor(palette.gray.mediumDark, palette.gray.mediumDark),
  pendingBackground: createColor(palette.backgrounds.lightYellow, palette.backgrounds.lightYellow),
  issuedBackground: createColor(palette.backgrounds.successGreen, 'transparent'),
  readyBackground: createColor(palette.backgrounds.lightBlue, palette.blue.pressed),
  approvedBackground: createColor(palette.backgrounds.successGreen, 'transparent'),
  rejectedBackground: createColor(palette.backgrounds.lightRed, 'transparent'),
  requestedBackground: createColor(palette.backgrounds.lightBlue, 'transparent'),
  onOrderBackground: createColor(palette.backgrounds.lightOnOrder, 'transparent'),
  pendingBorder: createColor(palette.semantic.warningOrange, palette.semantic.warningOrange),
  issuedBorder: createColor(palette.semantic.issuedGreen, palette.semantic.issuedGreen),
  readyBorder: createColor(palette.semantic.readyBlue, palette.semantic.readyBlue),
  onOrderBorder: createColor(palette.semantic.onOrderPurple, palette.semantic.onOrderPurple),
  defaultStatusBackground: createColor(palette.gray.veryLight, palette.gray.veryLight),
  defaultStatusText: createColor(palette.gray.darkest, palette.gray.darkest),
  defaultStatusBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  imageColor: createColor(palette.opacity.gray50, palette.opacity.gray50),

  partMessagesBGColor: createColor(palette.gray.white, palette.blue.softBlue),
  unReadMesageBGColor: createColor(palette.gray.disabledBG, palette.blue.onTint),

  ownPartsBorder: createColor(palette.gray.divider, palette.dark.techBorder),
  additionBadgeBG: createColor(palette.gray.additionalBadge, palette.dark.cardSelected),
  charCountBG: createColor(palette.gray.charCountGrey, palette.gray.charCountGrey),
  viewInstructionsCTAColor: createColor(palette.blue.primary, palette.gray.white),
  noViewInstructionsCTAColor: createColor(palette.dark.textLight, palette.dark.textLight),
  viewInstructionsBorderColor: createColor(palette.blue.primary, palette.blue.primary),
  meterRangeInfoBG: createColor(palette.opacity.blue08, palette.opacity.blue08),
  meterRangeInfoBorder: createColor(palette.blue.primary, palette.blue.primary),
  meterRangeInfoText: createColor(palette.blue.primary, palette.blue.primary),
  updateMeterCTAText: createColor(palette.gray.white, palette.gray.white),
  partsViewDisabledBGColor: createColor(palette.opacity.black10, palette.opacity.black10),
  meterModalTitleIconColor: createColor(palette.semantic.amberOrange, palette.semantic.amberOrange),
  accumulatedHoursExceededColor: createColor(palette.semantic.darkRed, palette.semantic.accumulatedErrorMainText),
  accumulatedHoursNormalColor: createColor(palette.gray.darkest, palette.gray.darkest),
  notesTickMark: createColor(palette.gray.darkest, palette.gray.white),
  accumulatedErrorText: createColor(
    palette.opacity.highPriorityBorder,
    palette.semantic.accumultedErrorText,
  ),
  repairHistoryNoteTitle: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  /** Upload drop-zone background.
   *  Light: neutral/50 slate (#F8FAFC). Dark: deep navy (#002859). */
  uploadContainerBG: createColor(palette.gray.slateLight, palette.blue.pressed),
  /** Attachment icon stroke colour.
   *  Light: onTint dark-navy (#020617). Dark: soft pastel blue (#99C7FF). */
  attachmentIconColor: createColor(palette.blue.onTint, palette.blue.soft),
  /** Search Parts modal — asset info bar background.
   *  Light: neutral/50 (#F3F4F6). Dark: neutral/900 (#26364A). */
  searchModalAssetBarBG: createColor(palette.gray.extraLight, palette.gray.lightDarkGrey),
  /** Search Parts modal — asset info bar border.
   *  Light: neutral/300 (#D0D0D0). Dark: neutral/800 (#3A4B61). */
  searchModalAssetBarBorder: createColor(palette.gray.neutral, palette.gray.darkGreyLight),
  /** Search Parts modal — asset info bar vertical separator line.
   *  Light: neutral/400 (#B6C2CF). Dark: neutral/600 (#3A4B61). */
  searchModalAssetBarSeparator: createColor(palette.gray.disabledCTABG, palette.gray.darkGreyLight),
  /** Tasks tab outer button background when active — brand primary (#005FCC) in both modes */
  tasksTabActiveBG: createColor(palette.blue.selectedText, palette.blue.selectedText),
  /** Search bar submit button background.
   *  Light: sky-blue tint (#EAF1FA) — matches the original design.
   *  Dark:  brand primary (#005FCC) — ensures the white arrow icon is visible. */
  searchBarButtonBG: createColor(palette.blue.sky, palette.blue.selectedText),
  /** Tasks tab badge/counter background when active.
   *  Light: white (same as completedRepairsText.light — no visible change).
   *  Dark:  #004EA8 (palette.blue.badge — brand badge fill). */
  tasksTabBadgeBG: createColor(palette.gray.white, palette.blue.badge),

  /** NoRecords illustration — large background blob fill.
   *  Light: original #F4F4F4. Dark: deepest navy (#001229). */
  noRecordsBgColor: createColor('#F4F4F4', palette.blue.softBlue),
  /** NoRecords illustration — shadow/angled layer + small decorative dot.
   *  Light: original #D9D9D9. Dark: pressed navy (#002859). */
  noRecordsShadowColor: createColor('#D9D9D9', palette.blue.pressed),
  /** NoRecords illustration — document/icon body fill (white rects).
   *  Light: white. Dark: badge blue (#004EA8). */
  noRecordsDocColor: createColor('#FFFFFF', palette.blue.badge),
  /** NoRecords illustration — magnifier/ellipse inner circle fill.
   *  Light: original #F3F4F6. Dark: badge blue (#004EA8). */
  noRecordsCircleColor: createColor('#F3F4F6', palette.blue.badge),
  /** NoRecords illustration — all stroke/outline paths and decorative elements.
   *  Light: original #AFAFAF. Dark: soft pastel blue (#99C7FF). */
  noRecordsBorderColor: createColor('#AFAFAF', palette.blue.soft),
};
